// extracted by mini-css-extract-plugin
export default {"wrapper":"Maintenance_wrapper__DJBwU","textMessage":"Maintenance_textMessage__NB1c5"};